module.exports = __webpack_public_path__ + "static/media/dotbit_logo-dark.0cc87d85.svg";